<app-top-navigation [class.blackGradient]="videoPlay"></app-top-navigation>
<app-panorama-container
		[autoRotateCamera]="true" [materialOpacity]="true"
		[panoramic]="'static/sites/panoramic/site-3-8ffe60a6-5c0e-4287-88df-fbf0cf000cb1.jpg'"
		style=" position: absolute;width: 100%; height: 82vh;"></app-panorama-container>
<div class="searchContainer">
	<div class="moto">
		Looking for a Virtual Tour?
	</div>
	<div class="searchArea">
		<div class="row">
			<div class="col-5 whereToGo">
				<label for="typeahead-template">Where you want to be guided</label>
				<input id="typeahead-template" type="text" class="form-control" [(ngModel)]="model" [ngbTypeahead]="search" [resultTemplate]="rt"
					   [inputFormatter]="formatter" placeholder="Select a location" />
			</div>
			<div class="col-5 whereToGo">
				<label for="typeahead-template">We speak your language</label>
				<ng-select [items]="['English', 'Ελληνικά', 'Русский', '繁體中文']" style="padding: 0;margin-top: -17px"
						   placeholder="Select your prefered language">
				</ng-select>
			</div>
			<div class="col-2">
				<div class="search">
					<a href="javascript:void(0)"
					   [routerLink]="[this.globalDataService.getRemoteContext()+'/'+this.translateService.currentLang+'/results']">
						<fa-icon [icon]="['fas','search']"></fa-icon>
					</a>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="mainContainer">
	<div class="container-fluid">
		<div class="sectionContainer">
			<h3 style="margin-top: 1rem;">Top Virtual Tours</h3>
			<div class="row topContainer">
				<div class="col-3">
					<figure>
						<img src="https://i.pinimg.com/originals/68/3f/ac/683face381a47d7843f5174d94019406.jpg"
							 focus="auto" height="262" width="382">
						<figcaption>
							<h3>Ancient Corinth</h3>
							<ul>
								<li>20 Tour Guides</li>
							</ul>
						</figcaption>
					</figure>
				</div>
				<div class="col-3">
					<figure>
						<img src="http://whyathens.com/wp-content/uploads/2016/10/Porch-Caryatids-Acropolis-Why-Athens-1024x512.jpg"
							 focus="auto" height="262" width="382">
						<figcaption>
							<h3>Athens Acropolis</h3>
							<ul>
								<li>100 Tour Guides</li>
							</ul>
						</figcaption>
					</figure>
				</div>
				<div class="col-3">
					<figure>
						<img src="https://www.greecetravel.com/peloponnesos/corinth/ancient-corinth02.jpg">
						<figcaption>
							<h3>Ancient Lyndos</h3>
							<ul>
								<li>50 Tour Guides</li>
							</ul>
						</figcaption>
					</figure>
				</div>
				<div class="col-3">
					<figure>
						<img src="https://letterstobarbara.com/wp-content/uploads/2021/03/ruins-at-ancient-corinth-1024x576.jpg">
						<figcaption>
							<h3>Olympeio</h3>
							<ul>
								<li>60 Tour Guides</li>
							</ul>
						</figcaption>
					</figure>
				</div>
			</div>

			<div class="partnerBanner" style="margin-top: 4rem;">
				<div class="bannerContainer">
					<img src="https://ulduztourism.az/wp-content/uploads/2017/09/role-tour-guide_5ee3912ff215781a.jpg" />
					<div class="bannerText">
						<div class="bannerInfo">
							<h3>Become a partner</h3>
							Join the family of CultureApp to gain more experience and an extra income.
						</div>
					</div>
					<button class="bannerMore">Learn More</button>
				</div>
			</div>
			<h3 style="margin-top: 6rem;">About us</h3>
			<div class="aboutUs">
				<p>Culture App is a company that revives the past of cultural heritage sites and historic monuments thanks to their 3D
				   representations,
				   in order to promote them around the world through the use of modern technological tools. This material along with current
				   illustrations and historical information are displayed on platform and on application, thus enriching the visitor experience
				   either by physical presence or remotely.
					<br>
					<br>
				   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla neque justo, aliquam at tortor ut, suscipit mattis justo. Integer
				   ultricies feugiat tellus id condimentum. Integer aliquet eu urna nec rutrum. Suspendisse mauris eros, dictum ut interdum vitae,
				   gravida sit amet odio. Vestibulum maximus enim ut ex dapibus molestie. Etiam rhoncus felis vel magna volutpat luctus. Fusce et mi
				   eget justo bibendum rutrum nec nec sem. Cras tempor vel justo non tristique. Nulla facilisi.
				   Vivamus quis rhoncus metus, vel viverra libero. Sed dapibus placerat magna at semper. Nulla ex eros, porttitor quis ipsum id,
				   imperdiet faucibus nisl. Quisque vehicula orci sapien. Ut a diam in dui venenatis ornare. Sed dui elit, ullamcorper sit amet
				   dignissim at, porttitor at mi. Mauris sapien mauris, interdum sit amet tortor at, tincidunt scelerisque quam. Nunc a laoreet magna.
				</p>
			</div>
		</div>
	</div>
	<div class="footerInfo">
		<div class="row">
			<div class="col-3">
				<label>Information</label>
				<ul>
					<li>How it works</li>
					<li>News</li>
					<li>Our guide partners</li>
				</ul>
			</div>
			<div class="col-3">
				<label>Guides</label>
				<ul>
					<li>Become a partner</li>
					<li>Guide list</li>
					<li>What you need to know</li>
				</ul>
			</div>
			<div class="col-3">
				<label>Policies</label>
				<ul>
					<li>Terms</li>
					<li>Privacy Policy</li>
				</ul>
			</div>
			<div class="col-3">
				<img src="assets/images/cards/visa.png" style="width: 39px;margin-right: 11px;">
				<img src="assets/images/cards/mastercard.png" style="width: 41px;margin-right: 9px;">
				<img src="assets/images/cards/diners.png" style="margin-right: 10px;width: 92px;">
				<img src="assets/images/cards/discover.png" style="width: 52px;"> <br />
				<label>
					Powered By
					<span style="width: 92%;">
						<img src="assets/images/cards/everypay.png" style="width: 93px;">
					</span>
				</label>
			</div>
			<div class="col-12" style="font-size: .7rem;margin-top: 10px;">
				COPYRIGHT © 2021 CULTUREAPP. ALL RIGHTS RESERVED
			</div>
		</div>
	</div>
</div>
<ng-template #rt let-r="result" let-t="term">
	<div class="row searchResutl">
		<div class="col-2 icon">
			<fa-icon [icon]="['fas','map-marker-alt']"></fa-icon>
		</div>
		<div class="col-10 results">
			<ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
			<div class="subTitle">{{r.country}}, {{r.region}}, {{r.state}}</div>
		</div>
	</div>
</ng-template>